export interface BreadcrumbItem {
  name?: string
  item?: string
  position?: number
}

interface Breadcrumbs {
  itemListElement?: BreadcrumbItem[]
}

export const priceRangeConditionsArray: string[] = [
  'Cartão Presente - Life',
  'Cartão Presente - Vivara',
  'Correntes',
]

function priceRangeConditions(breadcrumbs: Breadcrumbs | undefined): boolean {
  return (
    breadcrumbs?.itemListElement?.some((breadCrumbItem) =>
      priceRangeConditionsArray?.some(
        (condition) => breadCrumbItem?.name === condition
      )
    ) ?? false
  )
}

export default priceRangeConditions
